import { BookOpen, ClipboardList, MessageCircle } from 'lucide-react';

const features = [
  {
    Icon: BookOpen,
    alt: "Chat with documents",
    title: "AI-Powered PTE Learning",
    description: "Boost your PTE preparation with our intelligent AI — get real-time feedback on speaking, writing, and reading performance, personalized to your progress."
  },
  {
    Icon: ClipboardList,
    alt: "Take Notes",
    title: "Unlimited PTE Mock Tests with AI",
    description: "Access unlimited AI-evaluated PTE mock tests with instant scoring and detailed performance reports to help you track and improve effectively."
  },
  {
    Icon: MessageCircle,
    alt: "Real-Time Feedback",
    title: "Instant AI Feedback & Scoring",
    description: "Receive real-time AI scoring and feedback on all PTE sections — speaking, writing, reading, and listening — to accelerate your improvement."
  }
];


const CoreFeatures = () => {
  return (
    <div className="flex flex-col px-4 my-36 md:w-11/12 items-center mx-auto">
      <h2 className="text-3xl lg:text-4xl font-black text-center text-gray-800">CORE FEATURES</h2>
      <div className="flex flex-col md:flex-row justify-center items-center gap-12 lg:gap-24">
        {features.map((feature, index) => (
          <div key={index} className="flex flex-col items-center md:w-1/3 mt-12">
            <feature.Icon className="w-16 h-16 text-gray-600" />
            <h3 className="text-2xl font-semibold text-center mt-8 mb-4">{feature.title}</h3>
            <p className="text-base text-center">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreFeatures;
